import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [blur, setBlur] = useState(false);

  useEffect(() => {
    const navbarLinks = document.querySelectorAll('.header li');
    navbarLinks.forEach((link) => {
      link.addEventListener('mouseover', () => setBlur(true));
      link.addEventListener('mouseout', () => setBlur(false));
    });
  }, []);

  return (
    <div class="parent">
    <nav className={`header ${blur ? 'blur' : ''}`}>
      <ul>
        <li>
          <NavLink exact to="/" activeClassName="active">
          HINNI HELKALA
          </NavLink>
        </li>
      </ul>
    </nav>
    </div>
  );
};

export default Header;
